import React from 'react';
import { useSelector } from 'react-redux';
import FileUploadSectionContainer from '../containers/FileUploadSection';
import OutputContainer from '../containers/Output';
import './HomePage.scss';

function HomePage() {
  const { output } = useSelector((state) => state.global);

  const handleCopyCURL = () => {
    if (output) {
      const curlCommand = `curl --location --globoff 'https://routeoptimization.googleapis.com/v1/projects/{project_name}:optimizeTours' \\
--header 'Content-Type: application/json' \\
--header 'Authorization: Bearer $(gcloud auth application-default print-access-token)' \\
--data '${JSON.stringify(output, null, 2)}'`;

      navigator.clipboard.writeText(curlCommand).then(() => {
        alert('cURL command copied to clipboard!');
      });
    } else {
      alert('No output to copy as cURL!');
    }
  };

  const handleCopyJSON = () => {
    if (output) {
      navigator.clipboard.writeText(JSON.stringify(output, null, 2)).then(() => {
        alert('JSON copied to clipboard!');
      });
    } else {
      alert('No output to copy!');
    }
  };

  const handleDownload = () => {
    if (output) {
      const blob = new Blob([JSON.stringify(output, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'data.json';
      a.click();
      URL.revokeObjectURL(url); // Clean up the URL object
    } else {
      alert('No output to download!');
    }
  };

  return (
    <div className="HomePage">
      <div className="pannel">
        <div>
          <h1>GMPro Json Converter</h1>
          <FileUploadSectionContainer />
        </div>
      </div>
      <div className="main">
        <div className="main-top">
          <h2>Output</h2>
          <div className="action-buttons">
            <button className="copy-button" onClick={handleCopyCURL}>
              Copy cURL
            </button>
            <button className="copy-button" onClick={handleCopyJSON}>
              Copy JSON
            </button>
            <button className="download-button" onClick={handleDownload}>
              Download JSON
            </button>
          </div>
        </div>
        <div className="main-content">
          <OutputContainer />
        </div>
      </div>
    </div>
  );
}

export default HomePage;
